import { render } from "./TopBar.vue?vue&type=template&id=005c675d&ts=true"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\Waddecar Media\\Development\\Forms\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__